<template>
  <table class="table-condensed table-bordered table-striped layout-fixed">
    <thead ref="month">
      <tr>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th class="text-uppercase" :class="{ 'current-month': isCurrentMonth }">
          {{ months[currentMonth - 1] }}
        </th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <week-vue
        :current-month="currentMonth"
        :current-year="currentYear"
        :start-date="1"
        :fetch-appointment-details="false"
        :mark-day="'today'"
      />
      <week-vue
        v-for="start in startDaysOfWeek"
        :key="start"
        :current-month="currentMonth"
        :current-year="currentYear"
        :start-date="start"
        :fetch-appointment-details="false"
        :mark-day="'today'"
      />
    </tbody>
  </table>
</template>

<script>
import WeekVue from "./Week.vue";
import { mapMutations } from "vuex";
import { yearlyMonthlyMonthMixin } from "../../../mixins/yearlyMonthlyMonthMixin.js";
import { monthAndWeekMixin } from "../../../mixins/monthAndWeekMixin.js";

export default {
  mixins: [monthAndWeekMixin, yearlyMonthlyMonthMixin],
  props: {
    selectedMonth: Number
  },
  methods: {
    ...mapMutations({
      addMonthCoordinate: "addMonthCoordinate"
    })
  },
  components: {
    WeekVue
  },
  mounted() {
    const coordinates = this.$refs.month.getBoundingClientRect();
    let coordinate = { x: coordinates.x, y: coordinates.y - 111 };
    this.addMonthCoordinate({
      month: this.currentMonth - 1,
      coordinate
    });
  }
};
</script>

<style scoped>
.table-condensed .have-appointment-wrapper {
  top: 35px;
}
table >>> .selected-date a {
  background-color: #d26d13 !important;
}
</style>
